import axios from "axios";
import { useConfiguracoesHttpStore } from "@/store/configuracoesHttp"

const http = axios.create();

http.interceptors.request.use(
    config => {
        const uConfiguracoesHttpStore = useConfiguracoesHttpStore();
        config.headers['token'] = uConfiguracoesHttpStore.configuracoesHttp.Token;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default http